import { useQuoteWorkspaceContext } from 'contexts/quote-workspace.context';
import { useAppSelector } from 'hooks/useAppSelector';
import { getWorkspaceActiveTabId } from 'state/workspaces/workspaces/workspaces.selector';

export function useAssertedActiveTabId() {
  const workspace = useQuoteWorkspaceContext();
  return useAppSelector(state => getWorkspaceActiveTabId(state, workspace));
}
